import LeadCardTags from './LeadCardTags.component';

export default LeadCardTags;
